import Splide from '@splidejs/splide';

const EL = '.js-large-card-slider';

document.querySelectorAll('.js-large-card-slider').forEach((carousel) => {
  const slider = new Splide(carousel, {
    arrows: false,
    pagination: true,
    gap: 40,
    fixedWidth: '1010px',
    breakpoints: {
      1366: {
        fixedWidth: '800px',
        gap: 20,
      },
      1024: {
        fixedWidth: '680px',
      },
      767: {
        fixedWidth: '300px',
        gap: 10,
      },
    },
  });

  slider.mount();

  const prevButton = carousel.querySelector('.splide__nav--prev');
  const nextButton = carousel.querySelector('.splide__nav--next');

  const updateControls = () => {
    const currentSlide = slider.index + 1;
    const totalSlides = slider.length;
    const isLoop = slider.options.type === 'loop';

    if (!isLoop) {
      if (prevButton) prevButton.disabled = slider.index === 0;
      if (nextButton) nextButton.disabled = slider.index === totalSlides - 1;
    } else {
      if (prevButton) prevButton.disabled = false;
      if (nextButton) nextButton.disabled = false;
    }
  };


  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => slider.go('<'));
    nextButton.addEventListener('click', () => slider.go('>'));
  }

  slider.on('moved', updateControls);

  updateControls();
});
